import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { useTheme } from '@mui/material/styles';
import { Grid, Typography, Paper, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material';
import { gridSpacing } from 'utils/constants';
import MainCard from 'components/Cards/MainCard';
import ReportFileExports from 'components/Reports/FileExports';
import ApiHelper from 'utils/apiHelper';

const ReportsLicenseSummary = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false);
    const [licenseSummaryData, setLicenseSummaryData] = useState([]);
    const [totalLicenses, setTotalLicenses] = useState(0);
    const [usedLicenses, setUsedLicenses] = useState(0);

    useEffect(() => {
        getLicenseSummaryData();
    }, []);

    const getLicenseSummaryData = () => {
        setLoading(true);
        ApiHelper.get('/api/reports/license_summary/')
            .then((res) => {
                setLicenseSummaryData(res.data.results);
                setTotalLicenses(res.data.total_licenses);
                setUsedLicenses(res.data.used_licenses);
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
                toast.warning('There is no license summary data');
            });
    };

    return (
        <MainCard title="Operational Reports Management" cardHeaderTitle="License Summary" cardHeaderShow={true}>
            <Grid container spacing={gridSpacing}>
                <Grid item xs={10}>
                    <Typography sx={{ fontSize: '16px' }}>
                        Provides a breakdown of licenses and their usage by the various devices
                    </Typography>
                </Grid>
                {licenseSummaryData.length > 0 && (
                    <Grid item xs={2}>
                        <ReportFileExports
                            elementId="licenseSummary"
                            reportTitle="License Summary"
                            downloadFileName="license_summary"
                            downloadFileOption="all"
                            data={licenseSummaryData}
                            headers={[
                                { label: 'Issue Date', key: 'issue_date' },
                                { label: 'License Type', key: 'license_type' },
                                { label: 'License Total', key: 'total_licenses' },
                                { label: 'License Used', key: 'used_licenses' },
                                { label: 'License Left', key: 'left_licenses' },
                                { label: 'Expiration Date', key: 'expiration_date' }
                            ]}
                            filtersData={[]}
                        />
                    </Grid>
                )}
                <Grid item xs={12}>
                    <Paper sx={{ overflowX: 'hidden' }} id="licenseSummary">
                        {loading === true ? (
                            <Typography sx={{ mt: 3, textAlign: 'center', fontSize: '16px', fontWeight: 'bold' }}>
                                Please wait...
                            </Typography>
                        ) : licenseSummaryData.length === 0 ? (
                            <Typography sx={{ textAlign: 'center', mt: 3 }} color={theme.palette.secondary.main}>
                                No data for the license summary report
                            </Typography>
                        ) : (
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Issue Date</TableCell>
                                        <TableCell>License Type</TableCell>
                                        <TableCell>License Total</TableCell>
                                        <TableCell>License Used</TableCell>
                                        <TableCell>License Left</TableCell>
                                        <TableCell>Expiration Date</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {licenseSummaryData.map((data, key) => (
                                        <TableRow key={key}>
                                            <TableCell>{data.issue_date}</TableCell>
                                            <TableCell>{data.license_type}</TableCell>
                                            <TableCell>{data.total_licenses}</TableCell>
                                            <TableCell>{data.used_licenses}</TableCell>
                                            <TableCell>{data.left_licenses}</TableCell>
                                            <TableCell>{data.expiration_date}</TableCell>
                                        </TableRow>
                                    ))}
                                    <TableRow>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell>{totalLicenses.toString()}</TableCell>
                                        <TableCell>{usedLicenses.toString()}</TableCell>
                                        <TableCell>{(totalLicenses - usedLicenses).toString()}</TableCell>
                                        <TableCell></TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </MainCard>
    );
};

export default ReportsLicenseSummary;
